import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { Modal } from '../components/Modal';
import styles from './Prices.module.scss';

export const PricesPage = () => {
  const navigate = useNavigate();
  const [prices, setPrices] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editField, setEditField] = useState('');
  const [editValue, setEditValue] = useState('');

  const fetchPrices = async () => {
    try {
      setIsLoading(true);
      setError('');
      const { data } = await api.get('/admin/prices');
      setPrices(data?.prices || null);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load prices');
      setPrices(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPrices();
  }, []);

  const handleEditClick = field => {
    if (!prices) return;
    setEditField(field);
    const current = prices[field];
    setEditValue(
      typeof current === 'number' || typeof current === 'string' ? String(current) : ''
    );
    setIsEditOpen(true);
  };

  const handleEditClose = () => {
    setIsEditOpen(false);
    setEditField('');
    setEditValue('');
  };

  const handleEditConfirm = async () => {
    if (!editField) return;
    const numeric = Number(editValue);
    if (Number.isNaN(numeric)) {
      alert('Please enter a valid number.');
      return;
    }

    try {
      await api.patch('/admin/prices', { [editField]: numeric });
      await fetchPrices();
      handleEditClose();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to update price');
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <button
          type="button"
          className={styles.backLink}
          onClick={() => navigate('/admin/dashboard')}
        >
          ← Back to dashboard
        </button>
        <div className={styles.headerRow}>
          <h1 className={styles.header}>Prices</h1>
        </div>

        {isLoading && <p className={styles.empty}>Loading prices...</p>}

        {!isLoading && error && <p className={styles.error}>{error}</p>}

        {!isLoading && !error && !prices && (
          <p className={styles.empty}>No data.</p>
        )}

        {!isLoading && !error && prices && (
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.th}>Name</th>
                  <th className={styles.th}>Value</th>
                  <th className={styles.th}>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className={`${styles.td} ${styles.tdLabel}`}>Chat</td>
                  <td className={`${styles.td} ${styles.tdValue}`}>
                    {prices.chat !== undefined ? prices.chat : '-'}
                  </td>
                  <td className={styles.td}>
                    <button
                      type="button"
                      className={styles.backLink}
                      onClick={() => handleEditClick('chat')}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className={`${styles.td} ${styles.tdLabel}`}>AI chat</td>
                  <td className={`${styles.td} ${styles.tdValue}`}>
                    {prices.aiChat !== undefined ? prices.aiChat : '-'}
                  </td>
                  <td className={styles.td}>
                    <button
                      type="button"
                      className={styles.backLink}
                      onClick={() => handleEditClick('aiChat')}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className={`${styles.td} ${styles.tdLabel}`}>Remove sign</td>
                  <td className={`${styles.td} ${styles.tdValue}`}>
                    {prices.removeSign !== undefined ? prices.removeSign : '-'}
                  </td>
                  <td className={styles.td}>
                    <button
                      type="button"
                      className={styles.backLink}
                      onClick={() => handleEditClick('removeSign')}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className={`${styles.td} ${styles.tdLabel}`}>Extra operator</td>
                  <td className={`${styles.td} ${styles.tdValue}`}>
                    {prices.extraOperator !== undefined
                      ? prices.extraOperator
                      : '-'}
                  </td>
                  <td className={styles.td}>
                    <button
                      type="button"
                      className={styles.backLink}
                      onClick={() => handleEditClick('extraOperator')}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        <Modal
          isOpen={isEditOpen}
          title={
            editField
              ? `Edit ${editField}`
              : ''
          }
          onClose={handleEditClose}
          onConfirm={handleEditConfirm}
          confirmLabel="Save"
        >
          <div>
            <label
              style={{ display: 'block', fontSize: '0.85rem', marginBottom: '0.25rem' }}
            >
              New value
            </label>
            <input
              type="number"
              value={editValue}
              onChange={e => setEditValue(e.target.value)}
              style={{
                width: '100%',
                padding: '0.5rem 0.75rem',
                borderRadius: '0.5rem',
                border: '1px solid #d1d5db',
                fontSize: '0.9rem',
              }}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};

